<!-- 推荐人说明 -->
<template>
  <van-row>
    <van-col span="12" class="left">
      <div>推荐人</div>
      <div class="line2">推荐时间</div>
      <div
        v-if="$route.query.status === 5 || $route.query.status === 6"
        class="line2"
      >
        认购时间
      </div>
      <div v-if="$route.query.status === 6" class="line2">签约时间</div>
    </van-col>
    <van-col span="12" class="right">
      <div class="recommand-info">
        <div>{{ rec_username }}</div>
        <div>{{ rec_user_phone }}</div>
      </div>
      <div class="line2">{{ rec_date }}</div>
      <div
        v-if="$route.query.status === 5 || $route.query.status === 6"
        class="line2"
      >
        {{ subscribe_date }}
      </div>
      <div v-if="$route.query.status === 6" class="line2">{{ sign_date }}</div>
    </van-col>
  </van-row>
</template>

<script>
import { Col as VanCol, Row as VanRow } from "vant";
export default {
  components: { VanCol, VanRow },
  props: [
    "rec_username",
    "rec_user_phone",
    "rec_date",
    "subscribe_date",
    "sign_date",
  ],
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.left {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.right {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  padding-left: 30px;
  .line2 {
    text-align: right;
  }
  .recommand-info {
    display: flex;
    justify-content: space-between;
  }
}
.line2 {
  margin-top: 20px;
}
</style>
